import { CaseVoucherCategories } from '@debbie/common/dist/economy/vouchers/setup.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useVoucherTypes } from '@debbie/cortex/dist/voucher-types/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import ReactSelect from 'react-select';
const CaseVoucherTypeInput = (props) => {
    const allVoucherTypesLoadable = useVoucherTypes();
    const allVoucherTypes = h.hasData(allVoucherTypesLoadable)
        ? allVoucherTypesLoadable.data
        : null;
    const lang = useSelector((s) => s.lang);
    const voucherTypes = (allVoucherTypes || []).filter((type) => {
        if (props.excludeVoucherCategories) {
            return CaseVoucherCategories.filter((category) => !props.excludeVoucherCategories?.includes(category)).includes(type.category);
        }
        return CaseVoucherCategories.includes(type.category);
    });
    return (React.createElement(ReactSelect, { value: props.voucherTypeIds.map((voucherTypeId) => {
            const voucherType = voucherTypes.find((vt) => vt.voucherTypeId === voucherTypeId);
            return {
                value: voucherTypeId,
                label: voucherType
                    ? lang.pluralEconomyVoucherTypeLabels[voucherType.voucherTypeId] || voucherType.label
                    : voucherTypeId,
            };
        }), isMulti: true, placeholder: props.placeholder || lang.billingModels.selectVouchersGroup, classNamePrefix: "select", options: voucherTypes
            .filter((voucherType) => !props.excludeVoucherTypeIds?.includes(voucherType.voucherTypeId))
            .map((voucherType) => ({
            value: voucherType.voucherTypeId,
            label: `${lang.pluralEconomyVoucherTypeLabels[voucherType.voucherTypeId] ||
                voucherType.label}`,
        })), onChange: (val) => {
            return props.onChange(val.map((v) => v.value));
        } }));
};
export default CaseVoucherTypeInput;
//# sourceMappingURL=CaseVoucherTypeInput.js.map